import { PageMeta } from "@/components/common/Seo/PageMeta"
import AppListingPage from "@/components/getListed/appListing/AppListingPage"

const index = () => (
  <>
    <PageMeta
      meta={{
        title: "Get your app listed",
        description:
          "List your app or tokenized asset on Token Terminal. We turn your onchain data into standardized metrics that investors can compare and trust. Apply today.",
      }}
    />
    <AppListingPage />
  </>
)

export default index
